import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 32px;
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
`

export const MainContent = styled.div`
  max-width: 800px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`

export const HeaderIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const HeaderIcon = styled.span`
  font-size: 24px;
`

export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #1a1a1a;
  margin-bottom: 16px;
`

export const SubDescription = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 24px;
`

export const UpgradeButton = styled.button`
  background-color: #7c3aed;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 32px;

  &:hover {
    background-color: #6d28d9;
  }
`

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`

export const KnowledgeCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
`

export const CardIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CardIcon = styled.span`
  font-size: 24px;
`

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 4px 0;
`

export const CardDescription = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: #4a5568;
  margin: 0;
`

export const VideoSection = styled.div`
  position: sticky;
  top: 32px;
`

export const VideoThumbnail = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background-color: #e5f6f6;
  border-radius: 12px;
  overflow: hidden;
`

export const VideoOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const PlayButton = styled.button`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #ff4d00;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 16px;

  &:hover {
    transform: scale(1.05);
  }
`

export const PlayIcon = styled.span`
  color: white;
  font-size: 24px;
`

export const BrandLogo = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  text-transform: lowercase;
`

export const VideoLabels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export const Label = styled.span`
  background-color: #ffd700;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`

export const ChatbotsLabel = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
`
